export default __webpack_public_path__ + "static/media/PPI-patio-004.2f1f3fb9.jpg";